import { render, staticRenderFns } from "./OrderTimeUsage.vue?vue&type=template&id=8909989e&scoped=true"
import script from "./OrderTimeUsage.vue?vue&type=script&lang=js"
export * from "./OrderTimeUsage.vue?vue&type=script&lang=js"
import style0 from "./OrderTimeUsage.vue?vue&type=style&index=0&id=8909989e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8909989e",
  null
  
)

export default component.exports